module.exports = "/_next/static/images/9ea1bf686f326778b853ca41f32dcc2a-roxinho-details-metalico-md@2x.jpg";